import type { GuideArticle } from './articleTypes';

export const articles2: GuideArticle[] = [
  {
    slug: 'basetao-qc',
    tag: { en: 'QC Guide', fr: 'Guide QC', de: 'QC-Leitfaden', es: 'Guía QC', pt: 'Guia de QC' },
    image:
      'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20resting%20over%20a%20product%20inspection%20photo%20with%20a%20checklist%20and%20pen%20on%20a%20warm%20cream%20desk%20soft%20natural%20light%20sage%20green%20accents%20editorial%20still%20life%20photography%20high%20detail%20airy%20fresh%20aesthetic&width=800&height=600&seq=art-qc-01&orientation=landscape',
    metaTitle: {
      en: 'Basetao QC Guide: How to Read Quality Check Photos',
      fr: 'Guide QC Basetao : comment lire les photos de contrôle qualité',
      de: 'Basetao QC-Leitfaden: Qualitätskontroll-Fotos richtig lesen',
      es: 'Guía QC de Basetao: cómo leer las fotos de control de calidad',
      pt: 'Guia de QC do Basetao: como ler as fotos de controle de qualidade',
    },
    metaDescription: {
      en: 'Understand Basetao QC photos, what to check for quality, sizing and defects, and how to decide whether to accept or return an item.',
      fr: "Comprenez les photos QC de Basetao, ce qu'il faut vérifier pour la qualité et comment décider d'accepter ou de renvoyer un article.",
      de: 'Verstehe Basetao-QC-Fotos, worauf du bei Qualität und Mängeln achtest und wie du über Annahme oder Rücksendung entscheidest.',
      es: 'Entiende las fotos QC de Basetao, qué revisar en calidad y defectos, y cómo decidir aceptar o devolver un artículo.',
      pt: 'Entenda as fotos de QC do Basetao, o que verificar em qualidade e defeitos, e como decidir aceitar ou devolver um item.',
    },
    h1: {
      en: 'Basetao QC Guide: How to Read Quality Check Photos',
      fr: 'Guide QC Basetao : lire les photos de contrôle qualité',
      de: 'Basetao QC-Leitfaden: Qualitätskontroll-Fotos richtig lesen',
      es: 'Guía QC de Basetao: leer las fotos de control de calidad',
      pt: 'Guia de QC do Basetao: ler as fotos de controle de qualidade',
    },
    eyebrow: {
      en: 'BASETAO QC GUIDE',
      fr: 'GUIDE QC BASETAO',
      de: 'BASETAO QC-LEITFADEN',
      es: 'GUÍA QC DE BASETAO',
      pt: 'GUIA DE QC DO BASETAO',
    },
    intro: {
      en: 'Quality check photos are one of the most useful parts of buying through an agent. They let you see the actual item before it ships, so you can catch problems early instead of discovering them after delivery.',
      fr: "Les photos de contrôle qualité sont parmi les atouts les plus utiles de l'achat via un agent. Elles permettent de voir l'article réel avant expédition et de repérer les problèmes tôt.",
      de: 'Qualitätskontroll-Fotos gehören zu den nützlichsten Vorteilen beim Kauf über einen Agenten. Sie zeigen den Artikel vor dem Versand, damit du Probleme früh erkennst.',
      es: 'Las fotos de control de calidad son de lo más útil al comprar con un agente. Te dejan ver el artículo real antes del envío para detectar problemas a tiempo.',
      pt: 'As fotos de controle de qualidade são uma das partes mais úteis ao comprar com um agente. Elas mostram o item real antes do envio para detectar problemas cedo.',
    },
    sections: [
      {
        heading: {
          en: 'What QC Photos Usually Show',
          fr: 'Ce que montrent les photos QC',
          de: 'Was QC-Fotos normalerweise zeigen',
          es: 'Qué suelen mostrar las fotos QC',
          pt: 'O que as fotos de QC mostram',
        },
        body: {
          en: 'Photos typically capture the item from several angles, including close-ups of logos, stitching, tags and any details you asked to verify. They are your first real look at the product.',
          fr: "Les photos montrent généralement l'article sous plusieurs angles, avec des gros plans sur les logos, coutures, étiquettes et détails demandés. C'est votre premier vrai aperçu.",
          de: 'Die Fotos zeigen den Artikel meist aus mehreren Winkeln, inklusive Nahaufnahmen von Logos, Nähten, Etiketten und gewünschten Details.',
          es: 'Las fotos suelen mostrar el artículo desde varios ángulos, con primeros planos de logos, costuras, etiquetas y detalles solicitados.',
          pt: 'As fotos geralmente mostram o item de vários ângulos, com closes de logos, costuras, etiquetas e detalhes solicitados.',
        },
      },
      {
        heading: {
          en: 'What to Look For',
          fr: 'Ce qu’il faut vérifier',
          de: 'Worauf du achten solltest',
          es: 'Qué buscar',
          pt: 'O que observar',
        },
        body: {
          en: 'Check colors, logos, stitching, material and sizing against the listing. Look for stains, tears, uneven seams or anything that differs from what you expected to order.',
          fr: "Vérifiez couleurs, logos, coutures, matière et taille par rapport à l'annonce. Cherchez des taches, déchirures, coutures irrégulières ou tout écart avec votre commande.",
          de: 'Prüfe Farben, Logos, Nähte, Material und Größe gegen das Angebot. Achte auf Flecken, Risse, ungleiche Nähte oder Abweichungen.',
          es: 'Revisa colores, logos, costuras, material y talla contra el anuncio. Busca manchas, rotos, costuras irregulares o diferencias.',
          pt: 'Verifique cores, logos, costuras, material e tamanho em relação ao anúncio. Procure manchas, rasgos, costuras irregulares ou diferenças.',
        },
      },
      {
        heading: {
          en: 'Deciding to Accept or Return',
          fr: 'Accepter ou renvoyer',
          de: 'Annehmen oder zurücksenden',
          es: 'Aceptar o devolver',
          pt: 'Aceitar ou devolver',
        },
        body: {
          en: 'If the item matches your order, confirm it so shipping can begin. If something is clearly wrong, request a return or exchange before it leaves the warehouse, when it is easier and cheaper to fix.',
          fr: "Si l'article correspond, confirmez pour lancer l'expédition. En cas de problème évident, demandez un retour ou échange avant la sortie d'entrepôt, quand c'est plus simple et moins coûteux.",
          de: 'Wenn der Artikel passt, bestätige den Versand. Bei klaren Problemen fordere Rückgabe oder Tausch vor Verlassen des Lagers an, wenn es einfacher und günstiger ist.',
          es: 'Si coincide, confirma para enviar. Si algo está mal, pide devolución o cambio antes de que salga del almacén, cuando es más fácil y barato.',
          pt: 'Se corresponder, confirme para enviar. Se houver problema, peça devolução ou troca antes de sair do armazém, quando é mais fácil e barato.',
        },
      },
      {
        heading: {
          en: 'Using QC Photos With a Spreadsheet',
          fr: 'Utiliser les photos QC avec un tableur',
          de: 'QC-Fotos mit einer Tabelle nutzen',
          es: 'Usar fotos QC con una hoja de cálculo',
          pt: 'Usar fotos de QC com uma planilha',
        },
        body: {
          en: 'A Basetao spreadsheet often notes which sellers or items have good QC history. Pair those notes with the actual photos to make a more informed decision.',
          fr: "Un tableur Basetao note souvent les vendeurs ou articles ayant un bon historique QC. Combinez ces notes avec les photos réelles pour mieux décider.",
          de: 'Eine Basetao-Tabelle vermerkt oft, welche Verkäufer oder Artikel gute QC-Historie haben. Kombiniere diese Notizen mit den echten Fotos.',
          es: 'Una hoja Basetao suele anotar qué vendedores o artículos tienen buen historial QC. Combina esas notas con las fotos reales.',
          pt: 'Uma planilha Basetao costuma anotar quais vendedores ou itens têm bom histórico de QC. Combine essas notas com as fotos reais.',
        },
      },
    ],
    faqs: [
      {
        q: {
          en: 'Can I request extra QC photos?',
          fr: "Puis-je demander des photos QC supplémentaires ?",
          de: 'Kann ich zusätzliche QC-Fotos anfordern?',
          es: '¿Puedo pedir fotos QC adicionales?',
          pt: 'Posso pedir fotos de QC extras?',
        },
        a: {
          en: 'Yes, most agents let you request additional photos of specific details for a small fee or sometimes for free.',
          fr: "Oui, la plupart des agents permettent de demander des photos supplémentaires de détails précis, moyennant un petit supplément ou parfois gratuitement.",
          de: 'Ja, die meisten Agenten erlauben zusätzliche Fotos bestimmter Details gegen eine kleine Gebühr oder manchmal kostenlos.',
          es: 'Sí, la mayoría permite pedir fotos extra de detalles concretos por un pequeño cargo o a veces gratis.',
          pt: 'Sim, a maioria permite pedir fotos extras de detalhes por uma pequena taxa ou às vezes grátis.',
        },
      },
      {
        q: {
          en: 'What if QC photos reveal a defect?',
          fr: 'Que faire si les photos QC révèlent un défaut ?',
          de: 'Was tun, wenn QC-Fotos einen Mangel zeigen?',
          es: '¿Y si las fotos QC revelan un defecto?',
          pt: 'E se as fotos de QC revelarem um defeito?',
        },
        a: {
          en: 'Request a return or exchange before shipping. Acting early avoids the higher cost and hassle of an international return.',
          fr: "Demandez un retour ou échange avant l'expédition. Agir tôt évite le coût et la complexité d'un retour international.",
          de: 'Fordere Rückgabe oder Tausch vor dem Versand an. Frühes Handeln vermeidet die Kosten eines internationalen Rückversands.',
          es: 'Pide devolución o cambio antes del envío. Actuar a tiempo evita el coste de una devolución internacional.',
          pt: 'Peça devolução ou troca antes do envio. Agir cedo evita o custo de uma devolução internacional.',
        },
      },
      {
        q: {
          en: 'Do I always get QC photos?',
          fr: 'Reçois-je toujours des photos QC ?',
          de: 'Erhalte ich immer QC-Fotos?',
          es: '¿Siempre recibo fotos QC?',
          pt: 'Sempre recebo fotos de QC?',
        },
        a: {
          en: 'Inspection photos are a standard part of most agent orders, but confirm the specific policy before purchasing.',
          fr: "Les photos d'inspection font partie de la plupart des commandes, mais confirmez la politique avant d'acheter.",
          de: 'Inspektionsfotos sind bei den meisten Bestellungen Standard, bestätige aber die Richtlinie vor dem Kauf.',
          es: 'Las fotos de inspección son estándar en la mayoría de pedidos, pero confirma la política antes de comprar.',
          pt: 'As fotos de inspeção são padrão na maioria dos pedidos, mas confirme a política antes de comprar.',
        },
      },
    ],
  },
  {
    slug: 'basetao-coupon',
    tag: { en: 'Coupons', fr: 'Coupons', de: 'Gutscheine', es: 'Cupones', pt: 'Cupons' },
    image:
      'https://readdy.ai/api/search-image?query=A%20gift%20tag%20with%20a%20discount%20percentage%20and%20a%20pair%20of%20scissors%20on%20a%20warm%20cream%20surface%20with%20folded%20paper%20vouchers%20soft%20natural%20light%20sage%20green%20accents%20editorial%20still%20life%20photography%20high%20detail%20airy%20fresh%20aesthetic&width=800&height=600&seq=art-coupon-01&orientation=landscape',
    metaTitle: {
      en: 'Basetao Coupon & Discount Code: Latest Savings Guide',
      fr: 'Coupon Basetao et code promo : guide des dernières réductions',
      de: 'Basetao Gutschein und Rabattcode: Sparratgeber',
      es: 'Cupón Basetao y código de descuento: guía de ahorro',
      pt: 'Cupom Basetao e código de desconto: guia de economia',
    },
    metaDescription: {
      en: 'Find out how Basetao coupons and discount codes work, where to look for them and practical ways to save on fees and shipping.',
      fr: "Découvrez comment fonctionnent les coupons et codes promo Basetao, où les trouver et comment économiser sur les frais et la livraison.",
      de: 'Erfahre, wie Basetao-Gutscheine und Rabattcodes funktionieren, wo du sie findest und wie du bei Gebühren und Versand sparst.',
      es: 'Descubre cómo funcionan los cupones y códigos de Basetao, dónde encontrarlos y cómo ahorrar en tarifas y envío.',
      pt: 'Descubra como funcionam os cupons e códigos do Basetao, onde encontrá-los e como economizar em taxas e envio.',
    },
    h1: {
      en: 'Basetao Coupon & Discount Code: Latest Savings Guide',
      fr: 'Coupon Basetao et code promo : guide des réductions',
      de: 'Basetao Gutschein und Rabattcode: Sparratgeber',
      es: 'Cupón Basetao y código de descuento: guía de ahorro',
      pt: 'Cupom Basetao e código de desconto: guia de economia',
    },
    eyebrow: {
      en: 'BASETAO COUPON GUIDE',
      fr: 'GUIDE COUPON BASETAO',
      de: 'BASETAO GUTSCHEIN-GUIDE',
      es: 'GUÍA DE CUPONES BASETAO',
      pt: 'GUIA DE CUPONS BASETAO',
    },
    intro: {
      en: 'A small discount can add up when you are placing a large order. This guide explains the different kinds of Basetao savings, how to find them and how to make sure a code actually applies.',
      fr: "Une petite remise compte sur une grosse commande. Ce guide explique les différents types d'économies Basetao, comment les trouver et vérifier qu'un code s'applique.",
      de: 'Ein kleiner Rabatt summiert sich bei großen Bestellungen. Dieser Leitfaden erklärt die Spararten, wie du sie findest und prüfst, dass ein Code gilt.',
      es: 'Un pequeño descuento suma en un pedido grande. Esta guía explica los tipos de ahorro de Basetao, cómo encontrarlos y verificar que un código se aplica.',
      pt: 'Um pequeno desconto soma em um pedido grande. Este guia explica os tipos de economia do Basetao, como encontrá-los e conferir se um código funciona.',
    },
    sections: [
      {
        heading: {
          en: 'Types of Discounts',
          fr: 'Types de remises',
          de: 'Arten von Rabatten',
          es: 'Tipos de descuentos',
          pt: 'Tipos de descontos',
        },
        body: {
          en: 'Savings often come as percentage discounts on service fees, shipping vouchers or signup bonuses. Some are seasonal, while others run continuously.',
          fr: "Les économies se présentent souvent comme des remises en pourcentage sur les frais, des bons de livraison ou des bonus de bienvenue. Certaines sont saisonnières, d'autres permanentes.",
          de: 'Ersparnisse gibt es oft als Prozentrabatte auf Gebühren, Versandgutscheine oder Willkommensboni. Manche sind saisonal, andere dauerhaft.',
          es: 'Los ahorros suelen ser descuentos porcentuales en tarifas, vales de envío o bonos de registro. Algunos son de temporada, otros continuos.',
          pt: 'As economias costumam vir como descontos percentuais em taxas, vales de envio ou bônus de cadastro. Alguns são sazonais, outros contínuos.',
        },
      },
      {
        heading: {
          en: 'Where to Find Coupons',
          fr: 'Où trouver des coupons',
          de: 'Wo du Gutscheine findest',
          es: 'Dónde encontrar cupones',
          pt: 'Onde encontrar cupons',
        },
        body: {
          en: 'Check the official site, newsletters and social channels for active offers. Be careful with third-party code sites, as many list outdated or invalid codes.',
          fr: "Consultez le site officiel, les newsletters et les réseaux sociaux pour les offres actives. Méfiez-vous des sites tiers qui listent souvent des codes obsolètes.",
          de: 'Prüfe die offizielle Seite, Newsletter und Social-Kanäle auf aktive Angebote. Sei vorsichtig bei Drittanbieter-Seiten mit veralteten Codes.',
          es: 'Revisa el sitio oficial, boletines y redes sociales. Cuidado con sitios de terceros que suelen listar códigos obsoletos.',
          pt: 'Confira o site oficial, newsletters e redes sociais. Cuidado com sites de terceiros que listam códigos desatualizados.',
        },
      },
      {
        heading: {
          en: 'How to Apply a Code',
          fr: 'Comment appliquer un code',
          de: 'So wendest du einen Code an',
          es: 'Cómo aplicar un código',
          pt: 'Como aplicar um código',
        },
        body: {
          en: 'Enter the code in the designated field during checkout and confirm the discount appears before paying. If it does not apply, the code may be expired or limited to specific services.',
          fr: "Saisissez le code dans le champ prévu au paiement et vérifiez que la remise apparaît avant de payer. Sinon, le code peut être expiré ou limité.",
          de: 'Gib den Code im vorgesehenen Feld an der Kasse ein und prüfe, dass der Rabatt vor dem Bezahlen erscheint. Sonst ist er evtl. abgelaufen oder eingeschränkt.',
          es: 'Introduce el código en el campo del pago y confirma que el descuento aparece antes de pagar. Si no, puede estar caducado o limitado.',
          pt: 'Digite o código no campo do checkout e confirme o desconto antes de pagar. Se não aparecer, pode estar expirado ou limitado.',
        },
      },
      {
        heading: {
          en: 'Stacking and Timing',
          fr: 'Cumul et timing',
          de: 'Kombinieren und Timing',
          es: 'Combinar y elegir el momento',
          pt: 'Combinar e escolher o momento',
        },
        body: {
          en: 'Not all discounts can be combined, so read the terms. Timing a large order around a seasonal sale is often the easiest way to save more.',
          fr: "Toutes les remises ne se cumulent pas, lisez les conditions. Commander pendant une vente saisonnière est souvent le moyen le plus simple d'économiser davantage.",
          de: 'Nicht alle Rabatte sind kombinierbar, lies die Bedingungen. Eine große Bestellung während eines Saisonverkaufs spart meist am meisten.',
          es: 'No todos los descuentos se combinan; lee las condiciones. Pedir durante una venta de temporada es la forma más fácil de ahorrar más.',
          pt: 'Nem todos os descontos combinam; leia as condições. Pedir durante uma promoção sazonal é a forma mais fácil de economizar.',
        },
      },
    ],
    faqs: [
      {
        q: {
          en: 'Are Basetao coupons reliable?',
          fr: 'Les coupons Basetao sont-ils fiables ?',
          de: 'Sind Basetao-Gutscheine zuverlässig?',
          es: '¿Son fiables los cupones de Basetao?',
          pt: 'Os cupons do Basetao são confiáveis?',
        },
        a: {
          en: 'Codes from official sources are the most reliable. Third-party codes may be outdated, so always verify at checkout.',
          fr: "Les codes officiels sont les plus fiables. Les codes tiers peuvent être obsolètes, vérifiez toujours au paiement.",
          de: 'Codes aus offiziellen Quellen sind am zuverlässigsten. Drittanbieter-Codes können veraltet sein, prüfe immer an der Kasse.',
          es: 'Los códigos oficiales son los más fiables. Los de terceros pueden estar obsoletos; verifica al pagar.',
          pt: 'Códigos oficiais são os mais confiáveis. Códigos de terceiros podem estar desatualizados; verifique no checkout.',
        },
      },
      {
        q: {
          en: 'Can I use more than one code?',
          fr: 'Puis-je utiliser plusieurs codes ?',
          de: 'Kann ich mehrere Codes nutzen?',
          es: '¿Puedo usar más de un código?',
          pt: 'Posso usar mais de um código?',
        },
        a: {
          en: 'Usually only one code applies per order, but terms vary. Check the conditions for each promotion.',
          fr: "En général, un seul code s'applique par commande, mais cela varie. Vérifiez les conditions de chaque promotion.",
          de: 'Meist gilt nur ein Code pro Bestellung, das variiert aber. Prüfe die Bedingungen jeder Aktion.',
          es: 'Normalmente solo un código por pedido, pero varía. Revisa las condiciones de cada promoción.',
          pt: 'Normalmente apenas um código por pedido, mas varia. Verifique as condições de cada promoção.',
        },
      },
      {
        q: {
          en: 'Do discounts cover shipping?',
          fr: 'Les remises couvrent-elles la livraison ?',
          de: 'Decken Rabatte den Versand?',
          es: '¿Los descuentos cubren el envío?',
          pt: 'Os descontos cobrem o envio?',
        },
        a: {
          en: 'Some vouchers are specific to shipping, while others apply to service fees. Read what each code covers.',
          fr: "Certains bons concernent la livraison, d'autres les frais de service. Lisez ce que couvre chaque code.",
          de: 'Manche Gutscheine gelten für den Versand, andere für Gebühren. Lies, was jeder Code abdeckt.',
          es: 'Algunos vales son para envío, otros para tarifas. Lee qué cubre cada código.',
          pt: 'Alguns vales são para envio, outros para taxas. Leia o que cada código cobre.',
        },
      },
    ],
  },
  {
    slug: 'basetao-warehouse',
    tag: { en: 'Warehouse', fr: 'Entrepôt', de: 'Lager', es: 'Almacén', pt: 'Armazém' },
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20organized%20warehouse%20shelves%20with%20labeled%20cardboard%20boxes%20and%20a%20clipboard%20in%20the%20foreground%20on%20a%20warm%20cream%20palette%20soft%20natural%20light%20sage%20green%20accents%20editorial%20photography%20high%20detail%20airy%20fresh%20aesthetic&width=800&height=600&seq=art-warehouse-01&orientation=landscape',
    metaTitle: {
      en: 'Basetao Warehouse Guide: Storage, QC & Orders Explained',
      fr: 'Guide de l’entrepôt Basetao : stockage, QC et commandes',
      de: 'Basetao Lager-Guide: Lagerung, QC und Bestellungen erklärt',
      es: 'Guía del almacén Basetao: almacenamiento, QC y pedidos',
      pt: 'Guia do armazém Basetao: armazenamento, QC e pedidos',
    },
    metaDescription: {
      en: 'Understand how the Basetao warehouse works, how items are stored and consolidated, and how the storage period affects your orders.',
      fr: "Comprenez le fonctionnement de l'entrepôt Basetao, le stockage et la consolidation des articles et l'impact de la durée de stockage.",
      de: 'Verstehe, wie das Basetao-Lager funktioniert, wie Artikel gelagert und gebündelt werden und wie die Lagerzeit Bestellungen beeinflusst.',
      es: 'Entiende cómo funciona el almacén de Basetao, cómo se guardan y consolidan los artículos y cómo afecta el periodo de almacenamiento.',
      pt: 'Entenda como funciona o armazém do Basetao, como os itens são armazenados e consolidados e como o período de armazenamento afeta os pedidos.',
    },
    h1: {
      en: 'Basetao Warehouse Guide: Storage, QC & Orders Explained',
      fr: "Guide de l'entrepôt Basetao : stockage, QC et commandes",
      de: 'Basetao Lager-Guide: Lagerung, QC und Bestellungen',
      es: 'Guía del almacén Basetao: almacenamiento, QC y pedidos',
      pt: 'Guia do armazém Basetao: armazenamento, QC e pedidos',
    },
    eyebrow: {
      en: 'BASETAO WAREHOUSE GUIDE',
      fr: "GUIDE ENTREPÔT BASETAO",
      de: 'BASETAO LAGER-GUIDE',
      es: 'GUÍA DEL ALMACÉN BASETAO',
      pt: 'GUIA DO ARMAZÉM BASETAO',
    },
    intro: {
      en: 'The warehouse is the hub where your purchased items wait before international shipping. Knowing how storage and consolidation work helps you plan multi-item orders and avoid extra fees.',
      fr: "L'entrepôt est le point central où vos articles attendent avant l'expédition internationale. Comprendre le stockage et la consolidation aide à planifier les commandes multiples.",
      de: 'Das Lager ist der Knotenpunkt, wo gekaufte Artikel vor dem internationalen Versand warten. Wer Lagerung und Bündelung versteht, plant Mehrfachbestellungen besser.',
      es: 'El almacén es el centro donde tus artículos esperan antes del envío internacional. Entender el almacenamiento y la consolidación ayuda a planificar pedidos múltiples.',
      pt: 'O armazém é o centro onde seus itens aguardam antes do envio internacional. Entender armazenamento e consolidação ajuda a planejar pedidos múltiplos.',
    },
    sections: [
      {
        heading: {
          en: 'How Storage Works',
          fr: 'Comment fonctionne le stockage',
          de: 'Wie die Lagerung funktioniert',
          es: 'Cómo funciona el almacenamiento',
          pt: 'Como funciona o armazenamento',
        },
        body: {
          en: 'Each purchased item is received, logged and stored with your order number. Most services offer a free storage period, after which a small daily fee may apply.',
          fr: "Chaque article acheté est réceptionné, enregistré et stocké avec votre numéro de commande. La plupart offrent une période de stockage gratuite, puis un petit supplément quotidien peut s'appliquer.",
          de: 'Jeder gekaufte Artikel wird empfangen, erfasst und mit deiner Bestellnummer gelagert. Meist gibt es eine kostenlose Lagerzeit, danach kann eine kleine Tagesgebühr anfallen.',
          es: 'Cada artículo se recibe, registra y almacena con tu número de pedido. La mayoría ofrece un periodo gratuito, tras el cual puede aplicarse una pequeña tarifa diaria.',
          pt: 'Cada item é recebido, registrado e armazenado com seu número de pedido. A maioria oferece um período grátis, após o qual pode haver uma pequena taxa diária.',
        },
      },
      {
        heading: {
          en: 'Consolidating Items',
          fr: 'Consolider les articles',
          de: 'Artikel bündeln',
          es: 'Consolidar artículos',
          pt: 'Consolidar itens',
        },
        body: {
          en: 'Consolidation combines several items into one parcel, which often lowers total shipping cost. It is especially useful when buying from multiple sellers over several days.',
          fr: "La consolidation regroupe plusieurs articles en un colis, ce qui réduit souvent le coût total. C'est utile quand on achète auprès de plusieurs vendeurs sur plusieurs jours.",
          de: 'Die Bündelung fasst mehrere Artikel zu einem Paket zusammen, was die Gesamtkosten oft senkt. Das ist bei Käufen von mehreren Verkäufern über mehrere Tage hilfreich.',
          es: 'La consolidación combina varios artículos en un paquete, lo que suele reducir el coste total. Es útil al comprar a varios vendedores durante varios días.',
          pt: 'A consolidação combina vários itens em um pacote, o que costuma reduzir o custo total. É útil ao comprar de vários vendedores ao longo de dias.',
        },
      },
      {
        heading: {
          en: 'Free Storage Periods',
          fr: 'Périodes de stockage gratuites',
          de: 'Kostenlose Lagerzeiten',
          es: 'Periodos de almacenamiento gratuito',
          pt: 'Períodos de armazenamento grátis',
        },
        body: {
          en: 'The free period gives you time to collect items before shipping them together. Keep an eye on the deadline so you do not accidentally start paying storage fees.',
          fr: "La période gratuite vous laisse le temps de rassembler les articles avant de les expédier ensemble. Surveillez la date limite pour éviter les frais de stockage.",
          de: 'Die Gratiszeit lässt dir Zeit, Artikel vor dem gemeinsamen Versand zu sammeln. Behalte die Frist im Blick, um Lagergebühren zu vermeiden.',
          es: 'El periodo gratuito te da tiempo de reunir artículos antes de enviarlos juntos. Vigila el límite para no pagar tarifas de almacenamiento.',
          pt: 'O período grátis dá tempo de reunir itens antes de enviá-los juntos. Fique de olho no prazo para não pagar taxas de armazenamento.',
        },
      },
      {
        heading: {
          en: 'From Warehouse to Your Door',
          fr: "De l'entrepôt à votre porte",
          de: 'Vom Lager bis zu deiner Tür',
          es: 'Del almacén a tu puerta',
          pt: 'Do armazém à sua porta',
        },
        body: {
          en: 'Once you submit the parcel and choose a shipping line, the warehouse packs and dispatches it. You can then track the package through each stage until delivery.',
          fr: "Une fois le colis soumis et la ligne choisie, l'entrepôt emballe et expédie. Vous pouvez ensuite suivre le colis à chaque étape jusqu'à la livraison.",
          de: 'Sobald du das Paket einreichst und eine Linie wählst, verpackt und versendet das Lager. Danach kannst du das Paket bis zur Zustellung verfolgen.',
          es: 'Al enviar el paquete y elegir la línea, el almacén lo embala y despacha. Luego puedes rastrearlo hasta la entrega.',
          pt: 'Ao enviar o pacote e escolher a linha, o armazém embala e despacha. Depois você pode rastrear até a entrega.',
        },
      },
    ],
    faqs: [
      {
        q: {
          en: 'How long can I store items?',
          fr: "Combien de temps puis-je stocker les articles ?",
          de: 'Wie lange kann ich Artikel lagern?',
          es: '¿Cuánto tiempo puedo almacenar artículos?',
          pt: 'Por quanto tempo posso armazenar itens?',
        },
        a: {
          en: 'There is usually a free storage window, then a daily fee. The exact length varies, so check the current policy.',
          fr: "Il y a généralement une fenêtre gratuite, puis un supplément quotidien. La durée exacte varie, vérifiez la politique actuelle.",
          de: 'Meist gibt es ein Gratisfenster, dann eine Tagesgebühr. Die genaue Dauer variiert, prüfe die aktuelle Regelung.',
          es: 'Suele haber una ventana gratuita y luego una tarifa diaria. La duración varía; revisa la política actual.',
          pt: 'Geralmente há uma janela grátis e depois uma taxa diária. A duração varia; verifique a política atual.',
        },
      },
      {
        q: {
          en: 'Does consolidation save money?',
          fr: 'La consolidation permet-elle d’économiser ?',
          de: 'Spart Bündelung Geld?',
          es: '¿Consolidar ahorra dinero?',
          pt: 'Consolidar economiza dinheiro?',
        },
        a: {
          en: 'Yes, combining items into one parcel usually reduces total shipping cost compared to sending each item separately.',
          fr: "Oui, regrouper les articles en un colis réduit généralement le coût total par rapport à l'envoi séparé.",
          de: 'Ja, das Zusammenfassen zu einem Paket senkt meist die Gesamtkosten gegenüber Einzelversand.',
          es: 'Sí, combinar en un paquete suele reducir el coste total frente a enviar por separado.',
          pt: 'Sim, combinar em um pacote geralmente reduz o custo total em relação ao envio separado.',
        },
      },
      {
        q: {
          en: 'What happens to items after the storage limit?',
          fr: 'Que se passe-t-il après la limite de stockage ?',
          de: 'Was passiert nach Ablauf der Lagerzeit?',
          es: '¿Qué pasa tras el límite de almacenamiento?',
          pt: 'O que acontece após o limite de armazenamento?',
        },
        a: {
          en: 'Items may begin incurring storage fees or, in some cases, be disposed of after a long period. Ship your items before the deadline.',
          fr: "Les articles peuvent générer des frais ou, dans certains cas, être éliminés après une longue période. Expédiez avant la date limite.",
          de: 'Artikel können Lagergebühren verursachen oder nach langer Zeit entsorgt werden. Versende vor Ablauf der Frist.',
          es: 'Los artículos pueden generar tarifas o eliminarse tras un largo periodo. Envía antes del límite.',
          pt: 'Os itens podem gerar taxas ou ser descartados após um longo período. Envie antes do prazo.',
        },
      },
    ],
  },
  {
    slug: 'basetao-safety',
    tag: { en: 'Safety', fr: 'Sécurité', de: 'Sicherheit', es: 'Seguridad', pt: 'Segurança' },
    image:
      'https://readdy.ai/api/search-image?query=A%20shield%20symbol%20next%20to%20a%20padlock%20and%20a%20checklist%20on%20a%20warm%20cream%20desk%20with%20soft%20natural%20light%20sage%20green%20accents%20editorial%20still%20life%20photography%20high%20detail%20airy%20fresh%20aesthetic&width=800&height=600&seq=art-safety-01&orientation=landscape',
    metaTitle: {
      en: 'Is Basetao Legit? Safety, Trust & Buying Guide',
      fr: 'Basetao est-il fiable ? Sécurité, confiance et guide d’achat',
      de: 'Ist Basetao seriös? Sicherheit, Vertrauen und Kaufratgeber',
      es: '¿Basetao es legítimo? Seguridad, confianza y guía de compra',
      pt: 'O Basetao é legítimo? Segurança, confiança e guia de compra',
    },
    metaDescription: {
      en: 'Find out whether Basetao is legitimate, how to protect yourself when buying, and the warning signs to watch for before you order.',
      fr: "Découvrez si Basetao est légitime, comment vous protéger lors de vos achats et les signes d'alerte à surveiller avant de commander.",
      de: 'Erfahre, ob Basetao seriös ist, wie du dich beim Kauf schützt und welche Warnsignale du vor der Bestellung beachten solltest.',
      es: 'Descubre si Basetao es legítimo, cómo protegerte al comprar y las señales de alerta antes de pedir.',
      pt: 'Descubra se o Basetao é legítimo, como se proteger ao comprar e os sinais de alerta antes de pedir.',
    },
    h1: {
      en: 'Is Basetao Legit? Safety, Trust & Buying Guide',
      fr: 'Basetao est-il fiable ? Sécurité, confiance et guide d’achat',
      de: 'Ist Basetao seriös? Sicherheit, Vertrauen und Kaufratgeber',
      es: '¿Basetao es legítimo? Seguridad, confianza y guía de compra',
      pt: 'O Basetao é legítimo? Segurança, confiança e guia de compra',
    },
    eyebrow: {
      en: 'BASETAO SAFETY GUIDE',
      fr: 'GUIDE SÉCURITÉ BASETAO',
      de: 'BASETAO SICHERHEITS-GUIDE',
      es: 'GUÍA DE SEGURIDAD BASETAO',
      pt: 'GUIA DE SEGURANÇA BASETAO',
    },
    intro: {
      en: 'When money is involved, it is natural to ask whether a service is trustworthy. This guide looks at what makes Basetao a widely used agent, the risks that still exist and how you can protect yourself.',
      fr: "Quand de l'argent est en jeu, il est naturel de se demander si un service est fiable. Ce guide examine ce qui fait de Basetao un agent très utilisé, les risques restants et comment vous protéger.",
      de: 'Wenn Geld im Spiel ist, fragt man sich zu Recht, ob ein Dienst vertrauenswürdig ist. Dieser Guide beleuchtet, was Basetao zu einem verbreiteten Agenten macht, verbleibende Risiken und Schutzmaßnahmen.',
      es: 'Cuando hay dinero de por medio, es natural preguntarse si un servicio es fiable. Esta guía analiza qué hace a Basetao un agente popular, los riesgos y cómo protegerte.',
      pt: 'Quando há dinheiro envolvido, é natural questionar se um serviço é confiável. Este guia analisa o que torna o Basetao popular, os riscos e como se proteger.',
    },
    sections: [
      {
        heading: {
          en: 'What Makes a Service Legitimate',
          fr: 'Ce qui rend un service légitime',
          de: 'Was einen Dienst seriös macht',
          es: 'Qué hace legítimo a un servicio',
          pt: 'O que torna um serviço legítimo',
        },
        body: {
          en: 'A legitimate agent has a long track record, clear policies, real customer support and transparent pricing. Basetao has operated for years and serves buyers around the world.',
          fr: "Un agent légitime a un long historique, des règles claires, un vrai support client et des prix transparents. Basetao existe depuis des années et sert des acheteurs du monde entier.",
          de: 'Ein seriöser Agent hat eine lange Historie, klare Regeln, echten Support und transparente Preise. Basetao besteht seit Jahren und bedient Käufer weltweit.',
          es: 'Un agente legítimo tiene historial, políticas claras, soporte real y precios transparentes. Basetao opera desde hace años y atiende a compradores de todo el mundo.',
          pt: 'Um agente legítimo tem histórico, políticas claras, suporte real e preços transparentes. O Basetao opera há anos e atende compradores no mundo todo.',
        },
      },
      {
        heading: {
          en: 'Risks That Still Exist',
          fr: 'Les risques qui subsistent',
          de: 'Verbleibende Risiken',
          es: 'Riesgos que aún existen',
          pt: 'Riscos que ainda existem',
        },
        body: {
          en: 'No service can remove every risk. Sellers can send the wrong item, shipping can be delayed or customs can hold packages. Legitimacy does not mean zero risk.',
          fr: "Aucun service ne peut éliminer tous les risques. Les vendeurs peuvent envoyer un mauvais article, la livraison peut être retardée ou la douane retenir les colis.",
          de: 'Kein Dienst kann jedes Risiko ausschließen. Verkäufer können falsche Artikel senden, Versand kann sich verzögern oder Zoll Pakete zurückhalten.',
          es: 'Ningún servicio elimina todo riesgo. Los vendedores pueden enviar un artículo equivocado, el envío retrasarse o la aduana retener paquetes.',
          pt: 'Nenhum serviço elimina todo risco. Vendedores podem enviar o item errado, o envio atrasar ou a alfândega reter pacotes.',
        },
      },
      {
        heading: {
          en: 'How to Protect Yourself',
          fr: 'Comment vous protéger',
          de: 'So schützt du dich',
          es: 'Cómo protegerte',
          pt: 'Como se proteger',
        },
        body: {
          en: 'Review QC photos, keep records of your orders, verify seller signals and understand the refund policy before you pay. Small habits like these greatly reduce your risk.',
          fr: "Examinez les photos QC, gardez une trace de vos commandes, vérifiez les signaux vendeurs et comprenez la politique de remboursement avant de payer. Ces habitudes réduisent fortement le risque.",
          de: 'Prüfe QC-Fotos, halte Bestellungen fest, verifiziere Verkäufersignale und verstehe die Rückerstattungsregeln vor dem Bezahlen. Solche Gewohnheiten senken das Risiko deutlich.',
          es: 'Revisa las fotos QC, guarda registros, verifica señales de vendedores y entiende la política de reembolso antes de pagar. Estos hábitos reducen mucho el riesgo.',
          pt: 'Revise fotos de QC, guarde registros, verifique sinais de vendedores e entenda a política de reembolso antes de pagar. Esses hábitos reduzem muito o risco.',
        },
      },
      {
        heading: {
          en: 'Warning Signs to Avoid',
          fr: "Signes d'alerte à éviter",
          de: 'Warnsignale, die du meiden solltest',
          es: 'Señales de alerta a evitar',
          pt: 'Sinais de alerta a evitar',
        },
        body: {
          en: 'Be cautious of sellers with no history, prices that seem too good to be true and pressure to pay outside the platform. These are common red flags in any marketplace.',
          fr: "Méfiez-vous des vendeurs sans historique, des prix trop beaux pour être vrais et des pressions pour payer hors plateforme. Ce sont des signaux d'alerte classiques.",
          de: 'Sei vorsichtig bei Verkäufern ohne Historie, unrealistisch günstigen Preisen und Druck, außerhalb der Plattform zu zahlen. Das sind typische Warnsignale.',
          es: 'Desconfía de vendedores sin historial, precios irreales y presiones para pagar fuera de la plataforma. Son señales de alerta habituales.',
          pt: 'Desconfie de vendedores sem histórico, preços bons demais e pressão para pagar fora da plataforma. São sinais de alerta comuns.',
        },
      },
    ],
    faqs: [
      {
        q: {
          en: 'Is Basetao a scam?',
          fr: 'Basetao est-il une arnaque ?',
          de: 'Ist Basetao Betrug?',
          es: '¿Basetao es una estafa?',
          pt: 'O Basetao é golpe?',
        },
        a: {
          en: 'No. It is an established buying agent with years of operation. Still, always follow safe buying habits with any online purchase.',
          fr: "Non. C'est un agent d'achat établi depuis des années. Restez toutefois prudent comme pour tout achat en ligne.",
          de: 'Nein. Es ist ein etablierter Agent mit jahrelangem Betrieb. Befolge trotzdem sichere Kaufgewohnheiten.',
          es: 'No. Es un agente establecido con años de operación. Aun así, sigue hábitos de compra seguros.',
          pt: 'Não. É um agente estabelecido com anos de operação. Ainda assim, siga hábitos seguros de compra.',
        },
      },
      {
        q: {
          en: 'Is my payment safe?',
          fr: 'Mon paiement est-il sûr ?',
          de: 'Ist meine Zahlung sicher?',
          es: '¿Mi pago es seguro?',
          pt: 'Meu pagamento é seguro?',
        },
        a: {
          en: 'Payments are processed through standard channels, but no online transaction is risk-free. Use trusted payment methods and keep records.',
          fr: "Les paiements passent par des canaux standard, mais aucune transaction en ligne n'est sans risque. Utilisez des méthodes fiables et gardez des traces.",
          de: 'Zahlungen laufen über Standardkanäle, aber keine Online-Transaktion ist risikofrei. Nutze vertrauenswürdige Methoden und halte Aufzeichnungen fest.',
          es: 'Los pagos usan canales estándar, pero ninguna transacción en línea es sin riesgo. Usa métodos fiables y guarda registros.',
          pt: 'Os pagamentos usam canais padrão, mas nenhuma transação online é sem risco. Use métodos confiáveis e guarde registros.',
        },
      },
      {
        q: {
          en: 'What if my package is lost?',
          fr: 'Que faire si mon colis est perdu ?',
          de: 'Was tun, wenn mein Paket verloren geht?',
          es: '¿Y si mi paquete se pierde?',
          pt: 'E se meu pacote se perder?',
        },
        a: {
          en: 'Contact support with your tracking details. Refund or compensation depends on the shipping line and the specific situation.',
          fr: "Contactez le support avec vos informations de suivi. Le remboursement dépend de la ligne de livraison et de la situation.",
          de: 'Kontaktiere den Support mit deinen Tracking-Daten. Rückerstattung hängt von der Linie und der Situation ab.',
          es: 'Contacta al soporte con tu seguimiento. El reembolso depende de la línea y la situación.',
          pt: 'Entre em contato com o suporte com seus dados de rastreio. O reembolso depende da linha e da situação.',
        },
      },
    ],
  },
];